<template>
  <RevDrawer
    :close-button-label="i18n(translations.closeButtonLabel)"
    :name="PRODUCT.TELCO_COMPARISON_DRAWER"
    :title="i18n(translations.header)"
  >
    <template #body>
      <div class="space-y-32">
        <!-- Intro section: heading + paragraph -->
        <div class="space-y-8">
          <h2 class="heading-1">{{ i18n(translations.title) }}</h2>
          <p class="body-1">{{ i18n(translations.body) }}</p>
        </div>

        <!-- Per-partner cards (configured partners only: VISIBLE, NOBLE) -->
        <div class="space-y-24">
          <div
            v-for="plan in TELCO_PLAN_COMPARISONS"
            :key="plan.partnerName"
            class="border-static-default-mid bg-static-default-low space-y-24 rounded-md border p-16"
          >
            <!-- Partner logo + name -->
            <div class="flex items-center gap-12">
              <RevIllustration
                v-if="TELCO_PARTNER_LOGO_PATHS[plan.partnerName]"
                alt=""
                class="size-32 shrink-0 object-contain"
                :height="32"
                :src="TELCO_PARTNER_LOGO_PATHS[plan.partnerName]!"
                :width="32"
              />
              <h3 class="body-1-bold">{{ i18n(plan.name) }}</h3>
            </div>

            <!-- Benefit bullets -->
            <ul class="body-2 space-y-8 pl-16">
              <li
                v-for="bullet in plan.bullets"
                :key="bullet.id"
                class="list-disc"
              >
                {{ i18n(bullet) }}
              </li>
            </ul>

            <!-- Offer line in brand-accent text -->
            <p v-if="plan.offerLine" class="body-2 text-static-brand-hi">
              {{ i18n(plan.offerLine) }}
            </p>
          </div>
        </div>

        <!-- Footer info card: keep your number -->
        <div class="bg-static-default-mid space-y-8 rounded-lg p-16">
          <h3 class="body-2-bold">{{ i18n(translations.keepNumberTitle) }}</h3>
          <p class="body-2">{{ i18n(translations.keepNumberBody) }}</p>
        </div>
      </div>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import {
  TELCO_PARTNER_LOGO_PATHS,
  TELCO_PLAN_COMPARISONS,
} from '~/scopes/product-core/pages/ProductDetailPage/us/composables/useTelcoPicker/telcoPlanComparison.config'
import { PRODUCT } from '~/scopes/product-core/route-names'

import translations from './TelcoComparisonDrawer.translations'

const i18n = useI18n()
</script>
